import { useCallback, useState } from "react";

interface UseRequestCarrierResult {
  requestCarrier: (carrierName: string, isContracted: boolean) => void;
  loading: boolean;
  error: string | null;
  success: boolean;
}

// TODO: replace setTimeout with actual endpoint call in client.ts
export function useRequestCarrier(): UseRequestCarrierResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const requestCarrier = useCallback(
    (_carrierName: string, _isContracted: boolean) => {
      setLoading(true);
      setError(null);
      setSuccess(false);

      setTimeout(() => {
        setLoading(false);
        setSuccess(false);
        setError("Functionality not implemented yet");
        // TODO: call endpoint from client.ts and handle response/error
      }, 3000);
    },
    [],
  );

  return { requestCarrier, loading, error, success };
}
